import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-99e033f2")

_pushScopeId("data-v-99e033f2")
const _hoisted_1 = { class: "headTip" }
const _hoisted_2 = { class: "topText" }
const _hoisted_3 = { class: "topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "topText_one" }
const _hoisted_6 = {
  key: 1,
  class: "topText_xny"
}
const _hoisted_7 = { class: "topTags" }
const _hoisted_8 = {
  key: 0,
  class: "productname_wrapper productname_bg"
}
const _hoisted_9 = { class: "topText_small" }
const _hoisted_10 = { class: "head_promise_result_wrap" }
const _hoisted_11 = { class: "head_result_bg" }
const _hoisted_12 = { class: "result_wrap" }
const _hoisted_13 = { class: "resBox_top" }
const _hoisted_14 = { class: "reportLevel" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Описание системы оценки")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-gantanhao" }, null, -1)
const _hoisted_17 = { class: "resBox_top" }
const _hoisted_18 = { class: "top_levelDes" }
const _hoisted_19 = { class: "resbox_bottom" }
const _hoisted_20 = { class: "rectangle_resBox" }
const _hoisted_21 = {
  key: 0,
  class: "rectangle_resBox_item"
}
const _hoisted_22 = { class: "rectangle_resBox_item_txt" }
const _hoisted_23 = {
  key: 1,
  class: "rectangle_resBox_item"
}
const _hoisted_24 = { class: "rectangle_resBox_item_txt" }
const _hoisted_25 = {
  key: 2,
  class: "rectangle_resBox_item"
}
const _hoisted_26 = { class: "rectangle_resBox_item_txt" }
const _hoisted_27 = {
  key: 3,
  class: "rectangle_resBox_item"
}
const _hoisted_28 = { class: "rectangle_resBox_item_txt" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "result_line" }, null, -1)
const _hoisted_30 = { class: "result_bottom" }
const _hoisted_31 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_32 = {
  key: 0,
  class: "toc_ui__headTip_content_report_num"
}
const _hoisted_33 = { class: "batteryPop" }
const _hoisted_34 = { class: "batteryPopTitle" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Описание системы оценки ")
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "batteryPopTitleLine" }, null, -1)
const _hoisted_37 = { class: "batteryPopCont" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "batteryPopContTitle" }, [
  /*#__PURE__*/_createVNode("i", { class: "batteryPopContTitleLine" }),
  /*#__PURE__*/_createVNode("span", { class: "batteryPopContTitleTxt" }, "Общее состояние автомобиля")
], -1)
const _hoisted_39 = { class: "scoreLevelList" }
const _hoisted_40 = { class: "scoreLevelItem" }
const _hoisted_41 = { class: "scoreLevelInfo" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Имеются лишь незначительные поверхностные царапины, следы ремонта отсутствуют. Салон почти новый, без заметных следов эксплуатации. Двигатель и коробка передач работают отлично, всё электрооборудование исправно.", -1)
const _hoisted_43 = { class: "scoreLevelItem" }
const _hoisted_44 = { class: "scoreLevelInfo" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Имеются незначительные внешние дефекты и следы кузовного ремонта и окраски, не влияющие на общий внешний вид. В салоне присутствуют лёгкие следы эксплуатации, при этом он остаётся чистым и аккуратным. Двигатель и коробка передач работают стабильно. Всё электрооборудование исправно, неисправности и повреждения важных узлов отсутствуют.", -1)
const _hoisted_46 = { class: "scoreLevelItem" }
const _hoisted_47 = { class: "scoreLevelInfo" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "На кузове имеются многочисленные дефекты, а на отдельных участках — следы кузовного ремонта и окраски. Износ салона заметен. Некоторые детали автомобиля имеют признаки старения, возможны периодические неисправности.", -1)
const _hoisted_49 = { class: "scoreLevelItem" }
const _hoisted_50 = { class: "scoreLevelInfo" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Многочисленные внешние дефекты ухудшают общий внешний вид автомобиля. Салон сильно изношен, имеются локальные повреждения. Двигатель и коробка передач имеют заметный износ, возможны утечки масла, посторонние шумы и другие неисправности. Затраты на обслуживание и ремонт постепенно возрастают.", -1)
const _hoisted_52 = { class: "scoreLevelItem" }
const _hoisted_53 = { class: "scoreLevelInfo" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "Кузов подвергался значительному ремонту и имеет большое количество дефектов. Салон сильно изношен и серьёзно повреждён. Двигатель и коробка передач имеют сильные утечки масла и выраженные посторонние шумы, что создаёт угрозу безопасности движения. Ходовая часть имеет значительный износ и люфты. Большая часть электрооборудования неисправна, поэтому затраты на восстановление и ремонт будут высокими.", -1)
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopContTitle\" data-v-99e033f2><i class=\"batteryPopContTitleLine\" data-v-99e033f2></i><span class=\"batteryPopContTitleTxt\" data-v-99e033f2>Классификация аварийных повреждений</span></div><div class=\"accidentLevelList\" data-v-99e033f2><div class=\"accidentLevelItem\" data-v-99e033f2><div class=\"accidentLevelIcon level-a\" data-v-99e033f2>A</div><div class=\"accidentLevelDesc\" data-v-99e033f2>Структурные элементы и усилители кузова не имеют аварийных повреждений или следов ремонта. Наружные кузовные панели (кроме пластиковых деталей) не ремонтировались. Следы пожара и затопления отсутствуют.</div></div><div class=\"accidentLevelItem\" data-v-99e033f2><div class=\"accidentLevelIcon level-b\" data-v-99e033f2>B</div><div class=\"accidentLevelDesc\" data-v-99e033f2>Структурные элементы кузова не имеют аварийных повреждений или следов ремонта. На усилителях отсутствуют следы сварки или ремонта с применением резки. Допускается ремонт наружных кузовных панелей. Следы пожара и затопления отсутствуют.</div></div><div class=\"accidentLevelItem\" data-v-99e033f2><div class=\"accidentLevelIcon level-c\" data-v-99e033f2>C</div><div class=\"accidentLevelDesc\" data-v-99e033f2>Структурные элементы кузова не имеют аварийных повреждений или следов ремонта. На усилителях имеются следы сварочного ремонта. Следы пожара и затопления отсутствуют.</div></div><div class=\"accidentLevelItem\" data-v-99e033f2><div class=\"accidentLevelIcon level-c\" data-v-99e033f2>D</div><div class=\"accidentLevelDesc\" data-v-99e033f2>Имеются аварийные повреждения или ремонт структурных элементов, ремонт усилителей с применением резки, либо следы пожара или затопления.</div></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.getData('brandLogo'))
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.getData('brandLogo'),
                  class: "topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getData('brandSeriesName')), 1),
          (_ctx.getData('energyType') === '2')
            ? (_openBlock(), _createBlock("div", _hoisted_6, "新能源"))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          (_ctx.getData('detectItem'))
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("span", {
                  class: "productname_font productname",
                  text: _ctx.getData('detectItem')
                }, _toDisplayString(_ctx.getData("detectItem")), 9, ["text"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, "VIN: " + _toDisplayString(_ctx.getData("VIN")), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("img", {
            class: "syj_logo_bg",
            src: require('../../../../../assets/promiseFrame/syj_logo.png'),
            alt: ""
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", {
              class: ["result_middle", {"result_middle_nosf": !_ctx.state.showProtect}]
            }, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", {
                    class: "levelTxt",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
                  }, [
                    _createVNode("img", {
                      class: "levelNum",
                      src: require(`../../../../../assets/promiseFrame/${_ctx.getData('rank')}syj.png`),
                      alt: ""
                    }, null, 8, ["src"]),
                    _hoisted_15,
                    _hoisted_16
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.getData('rankDesc')), 1)
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("ul", _hoisted_20, [
                  (_ctx.getData('accidentFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_21, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_22, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('fireFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_23, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_24, _toDisplayString(_ctx.getData('fireFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('waterFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_25, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_26, _toDisplayString(_ctx.getData('waterFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('adjustFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_27, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('adjustFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_28, _toDisplayString(_ctx.getData('adjustFlag')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2),
            _hoisted_29,
            _createVNode("div", _hoisted_30, [
              _createVNode("span", _hoisted_31, "Код отчета: " + _toDisplayString(_ctx.getData('reportCode')), 1),
              (_ctx.getData('reportGenDate'))
                ? (_openBlock(), _createBlock("span", _hoisted_32, "Дата проверки: " + _toDisplayString(_ctx.getData('reportGenDate')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowPop,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.isShowPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
            })
          ]),
          _hoisted_36,
          _createVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/95ru.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_42
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("div", _hoisted_44, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/80ru.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_45
              ]),
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/65ru.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_48
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/50ru.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_51
              ]),
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/35ru.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_54
              ])
            ]),
            _hoisted_55
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})